import { render, staticRenderFns } from "./setRepeat.vue?vue&type=template&id=d979aff0&scoped=true"
import script from "./setRepeat.vue?vue&type=script&lang=js"
export * from "./setRepeat.vue?vue&type=script&lang=js"
import style0 from "./setRepeat.vue?vue&type=style&index=0&id=d979aff0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d979aff0",
  null
  
)

export default component.exports